export default defineNuxtPlugin(() => {
  const { data } = useAuth()

  return {
    provide: {
      me: computed(() => data.value!),
    },
  }
})
